if (!customElements.get("social-testimonials-slider")) {
  class SocialTestimonialsSlider extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll(".social-media-testimonial");
    }

    connectedCallback() {
      this.currentWidth = window.innerWidth;
      this.initSlider();

      window.addEventListener("resize", this.handleResize.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize.bind(this));
    }

    initSlider() {
      if (this.swpr) {
        this.swpr.destroy();
      }
      if (this.slides.length <= 1) {
        return;
      }

      const swiperContainer = this.querySelector(".swiper");

      if (!swiperContainer) return;

      const options = JSON.parse(swiperContainer.getAttribute('data-swiper-options')) || {};
      // Fallbacks for missing options
      options.slidesPerView = options.slidesPerView || 3;
      options.spaceBetween = options.spaceBetween || 10;
      options.loop = options.loop !== undefined ? options.loop : true;
      options.freeMode = options.freeMode !== undefined ? options.freeMode : true;
      options.speed = options.speed || 1500;
      options.grabCursor = options.grabCursor !== undefined ? options.grabCursor : true;
      options.autoplay = options.autoplay || {
        delay: 0,
        disableOnInteraction: true,
        reverseDirection: options.reverseDirection || false
      };
      options.breakpoints = options.breakpoints || {
        320: { slidesPerView: options.slidesPerViewMobile || 2 },
        768: { slidesPerView: options.slidesPerView || 3 }
      };

      this.swpr = new Swiper(swiperContainer, options);
    }

    handleResize() {
      if (this.currentWidth !== window.innerWidth) {
        this.currentWidth = window.innerWidth;
        this.initSlider();
      }
    }
  }

  customElements.define("social-testimonials-slider", SocialTestimonialsSlider);
}